<template>
  <div class="carousel position-relative">
    <div v-if="false&&this.panels.length>1" class="top-0 end-0 user-select-none p-2">
      <div class="row g-1 align-items-center">
        <div class="col cursor-pointer" @click="this.move(-1)">
          <svg width="12" height="10"><use href="/sprite.svg#arrow-left"/></svg>
        </div>
        <div class="col">|</div>
        <div class="col cursor-pointer" @click="this.move(1)">
          <svg width="12" height="10"><use href="/sprite.svg#arrow-right"/></svg>
        </div>
      </div>
    </div>
    <div v-for="(panel, idx) in panels" :key="panel.section">
      <slot name="panel" :panel="panel" :show="current === idx" :current="current+1" :total="this.panels.length" :move="move"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: ['panels'],
  data() {
    return {
      current: 0,
      rotate: false
    }
  },
  methods: {
    move: function (dir) {
      if (this.rotate)
        this.current = Math.abs((this.current + dir + this.panels.length) % this.panels.length);
      else
        this.current = Math.max(0, Math.min(this.panels.length - 1, this.current + dir));
    }
  }
}
</script>